import React from 'react'
import PropTypes from 'prop-types';
import {MovieItem} from './MovieItem'
import {DropdownButton, MenuItem} from 'react-bootstrap'
import {selectSection, selectAZ, selectMov2Filter} from '../../actions'
import MotionScroll from '../HomeView/MotionScroll';
//import $ from 'jquery'

export class MoviesView extends React.Component {
  constructor (props) {
    super(props)
    this.clickArrow = this.clickArrow.bind(this)
    this.onSectionClick = this.onSectionClick.bind(this)
    this.toggleAZorder = this.toggleAZorder.bind(this)
    this.onClickTagLabel = this.onClickTagLabel.bind(this)
    this.current_page=0
    this.maxpages = 0

    this.movie_list = null;
    this.state = {
      spos: 0,
    }
  }

  componentWillReceiveProps (nextProps) {
    this.current_page=0
  }

  toggleArrows () {
    if (Object.keys(this.refs).length === 0) {
      return
    }

    if (this.maxpages === 0) {
      this.refs.left_arrow_ico.classList.add('hide')
      this.refs.right_arrow_ico.classList.add('hide')
      return
    }

    if ((this.maxpages > 1) && (this.current_page < (this.maxpages-1))) {
      this.refs.right_arrow_ico.classList.remove('hide')
    } else {
      this.refs.right_arrow_ico.classList.add('hide')
    }

    if (parseInt(this.current_page, 10) !== 0) {
      this.refs.left_arrow_ico.classList.remove('hide')
    } else {
      this.refs.left_arrow_ico.classList.add('hide')
    }
  }

  clickArrow (direction) {
    // console.log('MoviesView clickArrow')
    //var jqEl = $(movie_list)
    if (direction === 'right') {
      this.current_page++
    } else {
      this.current_page--
      if (this.current_page < 0) {
        this.current_page = 0
      }
    }

    this.toggleArrows()
    const spos = this.current_page * this.movie_list.clientWidth;

    console.log('spos', spos);
    //jqEl.animate({scrollLeft: spos})
    this.setState({
      spos,
    })

    setTimeout(function () {
      window.dispatchEvent(new Event('resize'))
    }, 400)
  }

  renderSections () {
    /*
    const {sections, selectedSection} = this.props

    return (
      <DropdownButton noCaret ref='mydropdown' className='section-list' title={selectedSection}
        id='bg-justified-dropdown'>
      {sections.map((section, i) => {
        return (
          <MenuItem key={i} data-tag={section.name} onClick={this.onSectionClick} eventKey={i}>{section.name}</MenuItem>
        )
      })}
      </DropdownButton>
    )
    */

    const {movies_2016, scope, selectedSection, selectedMov2Filter} = this.props
    let sections, selectedSection_Movie
    let dropdown_direction = null

    if (scope !== 'festa') {
      sections = movies_2016.map((movie, i) => {
        return {
          id: movie.id,
          name: movie.title
        }
      })

      sections = [{
        id: 0,
        name: 'TODOS'
      }, ...sections]
      // selectedSection_Movie = selectedMov2Filter.mov_name

      selectedSection_Movie = (typeof selectedMov2Filter !== 'undefined')
        ? selectedMov2Filter.mov_name : 'FILMES'
      dropdown_direction = true
    } else {
      sections = this.props.sections
      selectedSection_Movie = selectedSection
    }

    return (
      <DropdownButton noCaret ref='mydropdown'
        className='section-list' pullRight={dropdown_direction}
        title={selectedSection_Movie}
        id='bg-justified-dropdown'>
      {sections.map((section, i) => {
        if (scope !== 'festa') {
          return (
            <MenuItem key={i} data-mid={section.id}
              data-tag={section.name} onClick={this.onSectionClick}
              eventKey={i}>{section.name}
            </MenuItem>
          )
        } else {
          return (
            <MenuItem key={i} data-mid={section.id} data-tag={section.name}
              onClick={this.onSectionClick} eventKey={i}>{section.name}
            </MenuItem>
          )
        }
      })}
      </DropdownButton>
    )
  }

  renderMovies () {
    const {movies_2016, isFetching, selectedSection, selectedMov2Filter} = this.props

    let movies = movies_2016

    if (this.props.scope !== 'festa' &&
      typeof selectedMov2Filter !== 'undefined' &&
      selectedMov2Filter.mov_id !== '0') {
      movies = movies_2016.filter((movie) => {
        return parseInt(movie.id, 10) === parseInt(selectedMov2Filter.mov_id, 10)
      })
    } else {
      if (typeof selectedSection !== 'undefined' && selectedSection !== 'SECÇÕES') {
        movies = movies_2016.filter((movie) => {
          return movie.name === selectedSection
        })
      }
    }

    if (isFetching && movies.length === 0) {
      this.toggleArrows()
      return (
        <h4 style={{color: '#ccc'}}>A carregar conteúdos...</h4>
      )
    }

    if (!isFetching && movies.length === 0) {
      this.maxpages = 0
      this.current_page=0
      this.toggleArrows()

      let feedback = `Não existem filmes da categoria "${selectedSection}"`
      if (selectedSection === 'SECÇÕES') {
        feedback = 'Não existem filmes'
      }

      return (
        <h4 style={{color: '#ccc'}}>{feedback}</h4>
      )
    }

    this.maxpages = Math.ceil(movies.length / 3)
    if (window.innerWidth < 600) {
      this.maxpages = movies.length
    }
    //this.current_page=0
    this.toggleArrows()
    //var jqEl = $(this.refs.movie_list)
    //jqEl.animate({scrollLeft: 0})

    /*
    this.setState({
      spos: 0
    })
    */

    if (this.props.selectedAZ === 1) {
      const orderedMovies = movies.sort(this.compare)
      return (
        orderedMovies.map((movie, i) => {
          return (
            <MovieItem type='movie' grid_size={3} onClickTagLabel={this.onClickTagLabel} movie={movie} key={i} />
          )
        })
      )
    } else {
      return (
        movies.map((movie, i) => {
          return (
            <MovieItem type='movie' grid_size={3} onClickTagLabel={this.onClickTagLabel} movie={movie} key={i} />
          )
        })
      )
    }
  }

  compare (a, b) {
    if (a.title < b.title) {
      return -1
    } else if (a.title > b.title) {
      return 1
    } else {
      return 0
    }
  }

  onSectionClick (e) {
    e.preventDefault()
    e.stopPropagation()

    if (this.props.scope !== 'festa') {
      this.props.dispatch(selectMov2Filter(e.target.getAttribute('data-mid'),
        e.target.getAttribute('data-tag')))
    } else {
      this.props.dispatch(selectSection(e.target.getAttribute('data-tag')))
    }
  }

  toggleAZorder (e) {
    e.preventDefault()
    e.stopPropagation()
    const orderByNameState = e.target.classList.contains('active') ? 0 : 1
    // console.log('orderByNameState', orderByNameState)
    this.props.dispatch(selectAZ(orderByNameState))
  }

  onClickTagLabel (tagname) {
    console.log('salta para ', tagname)
    this.props.onClickTagLabel(tagname)
  }

  render () {
    const {isFetching, selectedAZ} = this.props
    var leftArrowClick = this.clickArrow.bind(this, 'left')
    var rightArrowClick = this.clickArrow.bind(this, 'right')
    const orderByNameClass = selectedAZ === 1 ? 'active' : ''

    return (
      <div id='movies-view' className='row'>
        <div className='col-md-12'>
          <p className='section-title'>FILMES</p>
        </div>
        <div className='grid-header'>
          <p>Filtrar por</p>
          <div>
            {this.renderSections()}
            <button onClick={this.toggleAZorder} className={orderByNameClass}>FILMES A a Z</button>
          </div>
        </div>
        <div ref='left_arrow' className='col-xs-1 text-center no-pad-right' onClick={leftArrowClick}>
          <span ref='left_arrow_ico' className='arrow glyphicon glyphicon-chevron-left hide' aria-hidden='true'></span>
        </div>

        <div id='movie-list' ref={(d) => this.movie_list=d} className='col-xs-10 no-pad nowrap'
          style={{
            opacity: isFetching ? 0.5 : 1,
          }}>
            {this.renderMovies()}
        </div>

        <MotionScroll scrollLeft={this.state.spos} el={this.movie_list}/>

        <div ref='right_arrow' className='col-xs-1 text-center no-pad-left'
          onClick={rightArrowClick}>
          <span ref='right_arrow_ico' className='arrow glyphicon glyphicon-chevron-right' aria-hidden='true'></span>
        </div>
      </div>
    )
  }
}

MoviesView.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  scope: PropTypes.string.isRequired,
  movies_2016: PropTypes.array.isRequired,
  selectedSection: PropTypes.string.isRequired,
  selectedMov2Filter: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  sections: PropTypes.array.isRequired,
  selectedAZ: PropTypes.number.isRequired,
  onClickTagLabel: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/views/MoviesView/MoviesView.js